/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Repeat_Words_LabelInputs */



/**
* | output |
* | --- |
* | "Repeat Words" |
*
* @param {Style_Guide_Manager_Repeat_Words_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_repeat_words_label = /** @type {((inputs?: Style_Guide_Manager_Repeat_Words_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Repeat_Words_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Mots repetes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wörter wiederholen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ripeti le parole")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Повторить слова")
	if (locale === "es") return /** @type {LocalizedString} */ ("Repetir palabras")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("重复词语")
	if (locale === "ja") return /** @type {LocalizedString} */ ("単語を繰り返す")
	if (locale === "hi") return /** @type {LocalizedString} */ ("शब्दों को दोहराएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Repita as palavras")
	return /** @type {LocalizedString} */ ("Repeat Words")
});